import { IJsonModel, Layout, Model, TabNode } from 'flexlayout-react';
import { IIcons, ITitleObject } from 'flexlayout-react/declarations/view/Layout';
import React, { useEffect, useState } from 'react';
import { defaultSidebarWidth, LayoutData } from '../../model/Model';
import { ModuleEditor } from '../editor/module/ModuleEditor';
import { Changes } from '../sidebar/changes/Changes';
import { Finder } from '../sidebar/finder/Finder';
import './dark.scss';
import './FlexLayout.css';

const icons: IIcons = {

}

const jsonModelToLayoutData = (json: IJsonModel): LayoutData => {
  const sidebar = json.borders?.find(x => x.location === 'left')
  return {
    layout: json.layout,
    sidebar: {
      selectedTab: sidebar?.selected ?? null,
      width: sidebar?.size ?? defaultSidebarWidth,
    }
  }
}

const layoutDataToJsonModel = (layoutData:LayoutData, isRemote: boolean): IJsonModel => {
  return {
    global: { },
    layout: layoutData.layout,
    borders: [
      {
        type: 'border',
        location: 'top',
        enableDrop: false,
        show: true,
        barSize: 48,
        children: [ ]
      },
      {
        type: 'border',
        location: 'left',
        enableDrop: false,
        minSize: 100,
        barSize: 56,
        show: true,
        selected: layoutData?.sidebar?.selectedTab ?? undefined,
        size: layoutData?.sidebar?.width ?? defaultSidebarWidth,
        children: [
          {
            type: "tab",
            name: "",
            component: "sandbox",
            enableClose: false,
            enableDrag: false,
            icon: 'sandbox'
          },
          {
            type: "tab",
            name: "",
            component: "search",
            enableDrag: false,
            enableClose: false,
            icon: 'search'
          },

          ...isRemote ? [
            {
              type: "tab",
              name: "",
              component: "changes",
              enableDrag: false,
              enableClose: false,
              icon: 'changes'
            },
          ] : [],

          {
            type: "tab",
            name: "",
            component: "settings",
            enableDrag: false,
            enableClose: false,
            icon: 'settings'
          },

          ...isRemote ? [
            {
              type: "tab",
              name: "",
              component: "github",
              enableDrag: false,
              enableClose: false,
              icon: 'github'
            },
            {
              type: "tab",
              name: "",
              component: "deployment",
              enableDrag: false,
              enableClose: false,
              icon: 'deployment'
            },
          ] : []
        ]
      },
    ],
  }
}

const contentFactory = (node: TabNode) => {
  var component = node.getComponent();
  if (component === "editor") {
    const mode = node.getConfig()?.mode ?? 'local' as 'local' | 'remote' | 'changes'
    return <ModuleEditor id={node.getConfig().id} />
  } else if (component === "sandbox") {
    return <Finder mode="local" />
  } else if (component === 'changes') {
    return <Changes />
  }
  return undefined
}
const iconFactory = (node: TabNode): React.ReactNode | undefined => {
  switch (node.getIcon()) {
    case "sandbox": return <svg width="40" height="40" fill="none" viewBox="0 0 40 32" aria-hidden="true"><path fill="currentColor" d="M20.54 25a.681.681 0 00.158-.074l6.174-3.69c.734-.438 1.128-.885 1.128-2.084v-6.444c0-.248-.016-.447-.063-.629l-7.397 4.434zm-8.477-12.921l7.397 4.434V25a.514.514 0 01-.15-.074l-6.182-3.69c-.726-.438-1.128-.885-1.128-2.084v-6.444c0-.248.016-.447.063-.629zM20.004 7c.443 0 .9.143 1.359.406l.068.04 5.567 3.326c.155.088.284.177.394.282l.04.04-7.428 4.426-7.436-4.425c.11-.109.233-.198.378-.286l.063-.037 4.07-2.442h.002l1.488-.883c.434-.262.868-.415 1.296-.443l.071-.003z"></path></svg>
    case "search": return <svg width="40" height="40" fill="none" viewBox="0 0 40 32" aria-hidden="true"><path fill="currentColor" fillRule="evenodd" d="M20 26c5.523 0 10-4.477 10-10S25.523 6 20 6s-10 4.477-10 10 4.477 10 10 10zm-.46-15a4.54 4.54 0 102.404 8.393L24.8 22.45 26.25 21l-2.857-3.056A4.54 4.54 0 0019.54 11zm-2.49 4.54a2.49 2.49 0 114.98 0 2.49 2.49 0 01-4.98 0z" clipRule="evenodd"></path></svg>
    case "changes": return <svg width="40" height="40" viewBox="-8 -8 36 36" fill="none"><path d="M21.0067 8.22168C21.0102 7.52792 20.8205 6.84689 20.4589 6.25485C20.0971 5.66281 19.5778 5.18315 18.959 4.86957C18.3401 4.556 17.6461 4.42091 16.9548 4.47941C16.2635 4.53793 15.6022 4.78773 15.0448 5.20085C14.4875 5.61397 14.0561 6.17409 13.7991 6.8185C13.5421 7.4629 13.4695 8.16613 13.5895 8.84944C13.7096 9.53274 14.0174 10.1692 14.4787 10.6874C14.94 11.2056 15.5365 11.5852 16.2012 11.7836C15.9558 12.2824 15.576 12.703 15.1047 12.9979C14.6334 13.2929 14.0892 13.4505 13.5331 13.4532H10.5437C9.43702 13.4571 8.37138 13.8727 7.55427 14.6191V7.39809C8.46159 7.21288 9.26783 6.69737 9.81668 5.95151C10.3655 5.20565 10.6178 4.28256 10.5248 3.36121C10.4317 2.43987 9.99985 1.5859 9.31292 0.964873C8.62599 0.343845 7.73295 0 6.80691 0C5.88087 0 4.98783 0.343845 4.3009 0.964873C3.61397 1.5859 3.18211 2.43987 3.08904 3.36121C2.99596 4.28256 3.24831 5.20565 3.79715 5.95151C4.34599 6.69737 5.15223 7.21288 6.05955 7.39809V16.5159C5.15393 16.6891 4.34299 17.1877 3.77969 17.9176C3.21639 18.6476 2.93968 19.5585 3.00173 20.4785C3.06379 21.3984 3.46033 22.2639 4.11656 22.9115C4.77279 23.5592 5.64335 23.9444 6.56403 23.9944C7.48472 24.0445 8.39187 23.7558 9.1144 23.183C9.83693 22.6102 10.3249 21.7928 10.4862 20.885C10.6475 19.9771 10.4712 19.0417 9.99023 18.255C9.50932 17.4683 8.75717 16.8848 7.87564 16.6145C8.12152 16.1162 8.50142 15.6963 8.97272 15.4019C9.44401 15.1074 9.98803 14.9503 10.5437 14.9479H13.5331C14.4658 14.9436 15.3739 14.6486 16.1311 14.1039C16.8882 13.5592 17.4566 12.792 17.7572 11.9091C18.6531 11.7914 19.476 11.3528 20.0735 10.6748C20.671 9.9968 21.0025 9.12533 21.0067 8.22168ZM4.56483 3.73752C4.56483 3.29408 4.69633 2.8606 4.94269 2.4919C5.18906 2.12319 5.53922 1.83581 5.9489 1.66611C6.3586 1.49642 6.8094 1.45202 7.24432 1.53854C7.67924 1.62504 8.07874 1.83857 8.3923 2.15214C8.70586 2.4657 8.9194 2.8652 9.00591 3.30012C9.09241 3.73504 9.04802 4.18585 8.87832 4.59553C8.70862 5.00521 8.42125 5.35539 8.05254 5.60175C7.68383 5.84811 7.25035 5.9796 6.80691 5.9796C6.21227 5.9796 5.642 5.74339 5.22152 5.32291C4.80105 4.90245 4.56483 4.33216 4.56483 3.73752ZM9.04899 20.1794C9.04899 20.6229 8.91749 21.0563 8.67113 21.425C8.42476 21.7937 8.0746 22.0811 7.66492 22.2508C7.25523 22.4205 6.80442 22.4649 6.36951 22.3784C5.93458 22.292 5.53509 22.0784 5.22152 21.7648C4.90796 21.4512 4.69443 21.0517 4.60791 20.6169C4.52141 20.1819 4.5658 19.7311 4.7355 19.3214C4.9052 18.9117 5.19258 18.5615 5.56128 18.3152C5.92999 18.0689 6.36347 17.9373 6.80691 17.9373C7.40155 17.9373 7.97183 18.1736 8.3923 18.594C8.81277 19.0145 9.04899 19.5848 9.04899 20.1794ZM17.2699 10.4638C16.8265 10.4638 16.393 10.3322 16.0243 10.0859C15.6556 9.83954 15.3683 9.48937 15.1986 9.07969C15.0289 8.67 14.9844 8.2192 15.0709 7.78427C15.1574 7.34935 15.3709 6.94985 15.6845 6.63629C15.9981 6.32273 16.3976 6.10919 16.8325 6.02268C17.2674 5.93617 17.7183 5.98058 18.1279 6.15027C18.5377 6.31997 18.8878 6.60734 19.1341 6.97605C19.3805 7.34476 19.512 7.77823 19.512 8.22168C19.512 8.81632 19.2757 9.3866 18.8553 9.80706C18.4348 10.2275 17.8645 10.4638 17.2699 10.4638Z" fill="currentColor"/></svg>
    case "settings": return <svg width="40" height="40" fill="none" viewBox="0 0 40 32" aria-hidden="true"><path fill="currentColor" fillRule="evenodd" d="M21.253 6h-3.076l-.463 1.85a8.413 8.413 0 00-2.13.931l-1.567-.94-2.176 2.176.94 1.567a8.414 8.414 0 00-1.01 2.435L10 14.462v3.077l1.772.442c.209.872.553 1.692 1.01 2.435l-.94 1.567 2.175 2.176 1.566-.94c.744.456 1.564.8 2.436 1.01L18.46 26h3.077l.443-1.772a8.411 8.411 0 002.435-1.01l1.567.94 2.176-2.175-.94-1.567c.456-.743.8-1.563 1.01-2.435L30 17.538v-3.077l-1.772-.442a8.411 8.411 0 00-1.01-2.436l.94-1.566-2.175-2.176-1.567.94a8.408 8.408 0 00-2.736-1.076zM20 20.286a4.286 4.286 0 100-8.572 4.286 4.286 0 000 8.572z" clipRule="evenodd"></path></svg>
    case "github": return <svg width="40" height="40" fill="none" viewBox="0 0 40 32" aria-hidden="true"><path fill="currentColor" d="M17.242 26.224c-.08 0-.169-.008-.267-.026l.04-.446h.396a.39.39 0 00.159-.086.426.426 0 00.125-.241.561.561 0 00.008-.1c0-.242-.003-.468-.006-.771l-.013-1.25c-3.617.668-4.466-1.893-4.5-2.003-.579-1.467-1.371-1.84-1.373-1.841l-.03-.017c-1.826-1.254.21-1.231.217-1.231h.014c1.426.099 2.188 1.424 2.23 1.498.434.749.968 1.117 1.499 1.269.77.22 1.544-.005 2.002-.197.063-.379.167-.706.297-.984.088-.187.188-.352.295-.495-1.382-.196-2.768-.597-3.85-1.514-1.203-1.017-2.019-2.652-2.023-5.314a5.683 5.683 0 01.359-2.036c.23-.607.564-1.152.98-1.634a4.422 4.422 0 01-.227-1.154c-.044-.645.025-1.487.402-2.453l.009-.018s.164-.141.396-.154c.153-.008.385 0 .697.063.608.123 1.54.462 2.826 1.325a12.308 12.308 0 011.563-.317 13.052 13.052 0 013.492-.005c.532.071 1.057.175 1.566.312 2.581-1.744 3.772-1.362 3.776-1.361l.104.031.04.102c.382.966.454 1.806.412 2.45a4.438 4.438 0 01-.223 1.155c.418.48.753 1.023.984 1.63.235.614.363 1.293.364 2.037.004 2.669-.808 4.306-2.009 5.323-1.081.916-2.467 1.317-3.852 1.513.163.213.309.476.423.789.153.42.25.934.251 1.54.002 1.082-.004 2.208-.009 2.953l-.002.748c0 .034.003.07.01.108.018.09.057.176.125.237.037.034.084.061.143.08l.42-.002.042.446c-.1.02-.194.029-.282.03-.086 0-.165-.01-.237-.025l-7.532.013c-.071.015-.148.023-.23.023z"></path></svg>
    case "deployment": return <svg width="40" height="40" fill="none" viewBox="0 0 40 32" aria-hidden="true"><g fill="currentColor"><path fillRule="evenodd" d="M19.86 12.19l4.057-4.057c1.586-1.586 5.289-2.896 6.568-1.617s-.058 4.955-1.644 6.54l-4.056 4.057c-.34.34-.318.895-.152 1.347.997 2.718-3.89 7.541-3.89 7.541l-1.95-1.948 1.83-2.779-1.83.83-3.896-3.897.803-1.857-2.751 1.857L11 16.26s4.8-4.91 7.514-3.917c.451.165 1.007.187 1.347-.153z" clipRule="evenodd"></path><path d="M13.608 25.29a2.178 2.178 0 10-2.643-2.635L10 26.259z"></path></g></svg>
    case "live": return <svg width="40" height="40" fill="none" viewBox="0 0 40 32" aria-hidden="true"><g fill="currentColor" fillRule="evenodd" clipRule="evenodd"><path d="M15.222 19.113c2.193 0 3.976-2.108 4.023-4.533a.981.981 0 00.178-.48.92.92 0 00-.202-.698c-.114-2.225-.684-4.592-3.033-4.876l-.027-.003c-.681-.083-2.23-.27-2.548.665-2.144-.26-2.41 2.012-2.425 3.889-.248.153-.378.513-.297.886a.944.944 0 00.308.528c.005 2.463 1.804 4.622 4.023 4.622zm1.775 7.354c-.016-2.005-.032-4.022 2.003-5.304C17.645 18.895 5.439 19.5 8.487 27H17l-.003-.533z"></path><path d="M30.348 13.247c0 1.05-.374 2.087-.816 2.878-.1.179.08.482.262.786.199.333.398.667.226.839-.47.47-1.582.414-2.482.347-.59.517-1.303.819-2.07.819-.861 0-1.654-.382-2.284-1.022l-.514.24c-1.337-.177-2.162-2.377-1.844-4.914.319-2.537 1.66-4.45 2.997-4.272.307.065.584.15.835.251.575-.474 1.257-.75 1.988-.75 2.045 0 3.702 2.148 3.702 4.798zM18.602 26.85h13.36s.965-6.448-6.76-6.617c-7.726-.168-6.6 6.617-6.6 6.617z"></path></g></svg>
  }
  return undefined
}

const titleFactory = (node: TabNode): ITitleObject | React.ReactNode | undefined => {
  return undefined
}


export const FlexLayout = (props: {isRemote: boolean, layoutData: LayoutData, dispatch: (newModel: LayoutData) => Promise<void>}) => {
  const [state, setState] = useState(undefined as {
    jsonModel: IJsonModel,
    jsonStr: string,
    model: Model,
  } | undefined)
  
  useEffect(() => {
    const json = layoutDataToJsonModel(props.layoutData, props.isRemote)
    const newJsonStr = JSON.stringify(json)
    const json2 = JSON.parse(newJsonStr,(key, value) => value) // this removes all elements with symbols as key!
    if (state?.jsonStr !== newJsonStr) {
      setState({
        jsonModel: json2,
        jsonStr: newJsonStr,
        model: Model.fromJson(json2)
      })
    }
  }, [props.layoutData])


  if (state !== undefined) {
    return <Layout
        model={state.model}
        factory={contentFactory} 
        icons={icons}
        iconFactory={iconFactory}
        titleFactory={titleFactory}
        onModelChange={newModel => {
          console.log("MODEL CHANGE")
          const newJsonModel = newModel.toJson()
          setState({
            jsonModel: newJsonModel,
            jsonStr: JSON.stringify(newJsonModel),
            model: newModel
          })
          props.dispatch(jsonModelToLayoutData(newJsonModel))
        }}
    />
  } else {
    return <></>
  }
      
}